import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useContentfulContentTypeEntry } from '@order/Contentful';

/**
 * Returns the contentful data for the location search.
 */
export const useLocationContent = () => {
  const contentfulData = useContentfulContentTypeEntry<LocationContent>({
    contentType: 'location',
  });

  const content = contentfulData.data?.fields;
  const isFetchingContent = contentfulData.fetching;

  const { formatMessage } = useIntl();

  return useMemo(
    () => ({
      isFetchingContent,
      deliveryDisclosure: content?.deliveryDisclosure ?? formatMessage(fallbacks.deliveryDisclosure), // prettier-ignore
      outpostDisclosure: content?.outpostDisclosure ?? formatMessage(fallbacks.outpostDisclosure), // prettier-ignore
    }),
    [content, isFetchingContent, formatMessage],
  );
};

// ─── Fallbacks ──────────────────────────────────────────────────────────────

const fallbacks = defineMessages({
  deliveryDisclosure: {
    defaultMessage:
      'Thanks for choosing delivery. Higher menu prices and delivery fee apply.',
    description: 'Location | Delivery Disclosure',
  },
  outpostDisclosure: {
    defaultMessage: 'Thanks for choosing outpost. Higher menu prices apply.',
    description: 'Location | Outpost Disclosure',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type LocationContent = {
  deliveryDisclosure: string;
  outpostDisclosure: string;
};
